<script setup lang="ts">
  import { computed } from 'vue'

  const version = __APP_VERSION__
  const currentYear = new Date().getFullYear()
  const developmentYear = 2025

  const footerYear = computed(() => {
    if (currentYear > developmentYear) {
      return developmentYear + '-' + currentYear
    }

    return currentYear
  })
</script>

<template>
  <footer class="text-xs text-center flex justify-center items-center h-[var(--footer-height)]">
    v{{ version }} RAIN Boutique
    <!-- <router-link
        :to="{ name: 'changelogs' }"
        class="text-link">
        Riwayat Perubahan
      </router-link> -->
    &copy;{{ footerYear }}
  </footer>
</template>
